import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'
import { schoolApiSlice, SchoolStudent } from '../../../features/school/schoolSlice'
import ClassPicker from './ClassPicker'

interface Props {
    student: SchoolStudent
    onClose: () => void
}


const EditStudentDialog: React.FC<Props> = ({ student, onClose }) => {
    const { formatMessage } = useIntl()
    const [form, setForm] = useState({
        lastName: student.lastName,
        firstName: student.firstName,
        grade: student.grade ?? 0,
        literal: student.literal ?? '',
    })
    const [update, { isLoading }] = schoolApiSlice.useUpdateSchoolStudentMutation()

    const save = async () => {
        try {
            await update({ id: student.id, ...form }).unwrap()
            onClose()
        } catch { /* общий обработчик */ }
    }

    return (
        <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ fontWeight: 700 }}>{formatMessage({ id: 'edit' })}</DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1.5, mt: 1, mb: 2.5 }}>
                    <TextField size="small" label={formatMessage({ id: 'firstName' })} value={form.firstName}
                        onChange={(e) => setForm({ ...form, firstName: e.target.value })} />
                    <TextField size="small" label={formatMessage({ id: 'lastName' })} value={form.lastName}
                        onChange={(e) => setForm({ ...form, lastName: e.target.value })} />
                </Box>
                <ClassPicker grade={form.grade} literal={form.literal}
                    onChange={(grade, literal) => setForm({ ...form, grade, literal })} />
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={onClose}>{formatMessage({ id: 'cancel' })}</Button>
                <Button variant="contained" disabled={isLoading || !form.grade} onClick={save}>
                    {formatMessage({ id: 'save' })}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default EditStudentDialog
